import { document } from "assets";
import styled from "styled-components";

export const DocumentationWrapper = styled.div`
  overflow: hidden;
  /* background: rgba(3, 43, 136, 1); */
  background-image: url(${document});
  background-repeat: no-repeat;
  background-size: cover;
  .container {
    margin-top: 6rem;
    padding-bottom: 8rem;
  }

  .row {
    justify-content: center;
  }

  .col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  color: #032b88;
  text-align: center;
  margin-top: 4rem;
  padding-bottom: 4rem;
`;
